export default __webpack_public_path__ + "static/info-8f6ec61cf5bb6bad765562811c53e09e.png";